import environment from '../env'

const appConfig = {
    apiPrefix: environment.apiPrefix,
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'pt-BR',
    enableMock: environment.enableMock,
}

export default appConfig
